import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { putProject } from '#action/project/dashboard';
import {
  fetchProjectDevices,
  fetchProject,
  setFormData,
  changePage,
  setRemovedDevices,
  setAddedDevices,
  fetchFormDevices
} from '#action/project/devices-popup';
import { removeProjectDevices } from '#action/project/projects-paginated';
import { RemoveButton, AddButtonLabel } from '#component/device/devices-popup/styles';

const DeleteDevicesButton = props => {
  const {
    selected,
    setSelected,
    project,
    addMode,
    openedFromCreateForm,
    formDataObj,
    setFormDevices,
    formDevices: propsFormDevices
  } = props;
  const dispatch = useDispatch();
  const {
    page,
    removedDevices,
    newlyAddedDevices
  } = useSelector(s => s.projectDevicesPopup, shallowEqual);
  const formDevices = propsFormDevices || formDataObj?.formDevices || [];

  const handleRemove = async () => {
    const { title, beginDate, users, devices, id } = project;
    const selectedIds = selected.map(s => s.id);
    const newDevicesData = devices.filter(d => !selectedIds.includes(d));

    const data = {
      title,
      beginDate: beginDate.slice(0, 10),
      users,
      devices: newDevicesData
    };

    await dispatch(putProject(id, data));
    if (page !== 1) {
      await dispatch(changePage(1, project?.id, addMode, openedFromCreateForm, false));
    }
    await dispatch(fetchProjectDevices(id));
    await dispatch(fetchProject(id));
    setSelected([]);
    await dispatch(removeProjectDevices(id, newDevicesData.length));
  };

  const handleRemoveFormDevices = async () => {
    const selectedIds = selected.map(s => s.id);
    const newDevicesData = formDevices.filter(d => !selectedIds.includes(d.id));
    const newAddedDevices = newlyAddedDevices.filter(d => !selectedIds.includes(d.id));

    setFormDevices?.(newDevicesData);

    await dispatch(setAddedDevices(newAddedDevices));
    await dispatch(setRemovedDevices([...removedDevices, ...selected]));
    await dispatch(setFormData(newDevicesData));
    await dispatch(fetchProjectDevices(project?.id, addMode, true));
    setSelected([]);

    if (newDevicesData.length && newDevicesData.length < 11) {
      const filteredIds = newDevicesData.map(d => d.id);
      const projectDevices = await fetchFormDevices(filteredIds);
      setFormDevices?.(projectDevices);
    }
  };

  return (
    <RemoveButton
      size="small"
      aria-label="Remove"
      onClick={openedFromCreateForm ? handleRemoveFormDevices : handleRemove}
    >
      <AddButtonLabel>{`Remove selected (${selected?.length})`}</AddButtonLabel>
    </RemoveButton>
  );
};

export default DeleteDevicesButton;
